import script from "./ReportesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportesPage.vue?vue&type=script&setup=true&lang=js"

import "./ReportesPage.vue?vue&type=style&index=0&id=152aa029&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-152aa029"]])

export default __exports__